import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Icon} from 'ui-library';

module.exports = createClass({

  displayName: 'WizardItem',

  propTypes: {
    step: PropTypes.number.isRequired,
    currentStep: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string
  },

  getDefaultProps() {
    return {
      state: 2
    };
  },

  render() {
    const {step, currentStep, className, title, text} = this.props;
    let classes = 'vf-wizard-item ';
    if (step < currentStep) classes += ' done';
    if (step === currentStep) classes += ' active';
    if (step > currentStep) classes += ' inactive';
    if (className) classes += ` ${className}`;

    const isDone = step < currentStep;

    return (
      <div className={classes}>
        <div className='vf-wizard-item-step'>
          {isDone ? <Icon icon='checkmark' /> : step}
        </div>

        <div className='vf-wizard-item-title'>
          {title}
        </div>

        {text &&
          <div className='vf-wizard-item-text'>
            {text}
          </div>
        }
      </div>
    );
  }
});
